package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/a-series-of-unfortunate-events". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/a-series-of-unfortunate-events")
@Composable
fun ASeriesOfUnfortunateEventsReviewPage() {
    PublicReviewPage(
        slug = "a-series-of-unfortunate-events",
        blurb = "Is A Series of Unfortunate Events OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
